import { datadogRum } from '@datadog/browser-rum';
import React, { useContext, useEffect } from 'react';
import { getFuseTag } from 'utilities/fuse';
import { messageLog } from 'utilities/helpers/logger/message-logger';
import { PageChangeContext } from 'utilities/hooks/page-change-context';
import { normalisedUrl } from 'utilities/router/api-fetch-path';
import { getWindow } from 'utilities/window';

/**
 * Updates on page navigation sends whenever new url is sent
 * Updates of Nielsen Tracking
 * Starts a new DataDog RUM view
 * */
export const PageNavigationHook = ({ children }: { children: React.ReactNode }): React.ReactNode => {
  const { pageUrlChanged, getCurrentPath } = useContext(PageChangeContext);

  useEffect(() => {
    const isInit = pageUrlChanged === undefined;
    const currentPage = pageUrlChanged ?? getCurrentPath();
    /** Update Nielsen Page */
    getWindow()?.nielsenQueue.set({ init: isInit });
    /** Update Datadog Page */
    messageLog.trace(`[PATH] ${isInit ? '[INIT]' : '[NAV]'} View ${normalisedUrl(currentPage)}`);
    datadogRum.startView({
      name: normalisedUrl(currentPage),
    });
    /**
     * See ads-ready-provider for other datadog timers
     * e.g. datadogRum.addTiming(`Log_Fuse_${name}_${suffix}`);
     */

    if (pageUrlChanged) {
      /** Update Fuse Tags */
      /** Clear fuseTags to restart getting ads when new components are built */
      const fusetagLib = getFuseTag();
      /** We a timeout here as we need to give the ad components time to update their attributes before refreshing */
      fusetagLib.que.push(() => {
        fusetagLib.pageInit();
      });
    }
  }, [pageUrlChanged, getCurrentPath]);

  return children;
};
